module.exports = __webpack_public_path__ + "img/stoper-icon-white.6fa67e51.svg";